import { InjectionToken } from '@angular/core';
import { IAuthService } from '@/core/interface/auth-service.interface';

/** DIP: consumers inject IAuthService, not the concrete AuthService class */
export const AUTH_SERVICE_TOKEN = new InjectionToken<IAuthService>('AUTH_SERVICE_TOKEN');
